<h2>{{ title }}</h2>
<div class="correlation-value" dir="ltr">
  {{ value !== null ? (value | number:'1.3-3':'en-US') : '—' }}
</div>
<p>{{ value !== null ? description : 'داده کافی برای محاسبه همبستگی وجود ندارد' }}</p>
